import type { EntriesDetails } from '@betterpool/api-types/contests-service';

function getContestMaxEntriesLabel(entries: EntriesDetails) {
  return entries.max === 0 && entries.is_unlimited_entries
    ? '∞'
    : entries.max;
}

export default getContestMaxEntriesLabel;
